// src/components/Section.js
import React from 'react';
import { motion } from 'framer-motion'; // <-- IMPORT motion
import PropTypes from 'prop-types';

// --- TEMPORARY Local Definitions (Recommend moving to central files) ---
const colors = {
    background: "bg-slate-100", // Example default background
    // Add any other colors DIRECTLY used by Section styling if any
};

const viewportOnce = { once: true, amount: 0.1 };

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
};
// --- End Temporary Definitions ---

const Section = ({
    children,
    className = "",
    bg = colors.background, // Use locally defined colors
    ariaLabelledby
}) => (
  <motion.section
      className={`py-12 md:py-16 ${bg} ${className}`}
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce} // Use locally defined settings
      variants={staggerContainer} // Use locally defined variant
      aria-labelledby={ariaLabelledby}
  >
      <div className="container mx-auto px-4 sm:px-6 max-w-5xl">
          {children}
      </div>
  </motion.section>
);

Section.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    bg: PropTypes.string,
    ariaLabelledby: PropTypes.string,
};

export default Section;
